/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Contact_TitleInputs */

const en_meta_contact_title = /** @type {(inputs: Meta_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Lindevo — talk to an AI automation engineer | Lindevo`)
};

const lv_meta_contact_title = /** @type {(inputs: Meta_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakti — AI konsultācijas un 30 minūšu saruna | Lindevo`)
};

/**
* | output |
* | --- |
* | "Contact Lindevo — talk to an AI automation engineer \| Lindevo" |
*
* @param {Meta_Contact_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const meta_contact_title = /** @type {((inputs?: Meta_Contact_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Contact_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_meta_contact_title(inputs)
	return en_meta_contact_title(inputs)
});